export default __webpack_public_path__ + "static/media/7.0d380a02.webp";